export * from './stock-in-bin-view.component';